<script>
import OrganizationStaffList from '@/components/org/OrganizationStaffList'
import BottomToolbar from '@/components/org/BottomToolbar'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-staff-list',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'organization-staff-list': OrganizationStaffList,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staffList: null,
            organizationId: null,
            matchId: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onStaffItemClick(item) {
            console.log('onStaffItemClick', item)
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgDetailStaff',
                    params: {
                        id: item.id
                    },
                    query: {
                        organizationId: this.organizationId,
                        isMatchOperator: (item.role == '2') ? 'true' : 'false',
                        matchId: this.matchId,
                        from: 'OrgListMatchStaff'
                    }
                }
            })
        },
        onStaffItemCreate() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateStaff',
                    query: {
                        organizationId: this.organizationId,
                        matchId: this.matchId,
                        from: 'OrgListMatchStaff'
                    }
                }
            })
        },
        onStaffInvite(item) {
            console.log('onStaffInvite', item)
            this.$emit('custom-event', {
                type: 'invite',
                data: {
                    id: item.id,
                    organizationId: this.organizationId,
                    role: item.role,
                    roleLabel: item.roleLabel,
                }
            })
        },
        onCreateBtnClick() {
            console.log('onCreateBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgCreateStaff',
                    query: {
                        organizationId: this.organizationId,
                        matchId: this.matchId,
                        from: 'OrgListMatchStaff'
                    }
                }
            })
        },
    },
}
</script>

<template>
    <div class="match-staff-list">
        <organization-staff-list
            :staffList="staffList"
            :staffEmptyHint="locale['staff-empty-hint']"
            :staffInviteLabel="locale['staff-invite-label']"
            :isRoleNameShow="true"
            @create-item="onStaffItemCreate"
            @click-item="onStaffItemClick"
            @invite-staff="onStaffInvite"
        />
        <bottom-toolbar 
            type="button" 
            :mainButtonLabel="locale['create']"
            @click-main-button="onCreateBtnClick"
        />
    </div>
</template>